export default function LazyLoading() {
  return (
    <div aria-busy="true" className="text-center min-h-[80vh]">
      ...
    </div>
  );
}
